export default {
  pageTitle: 'Tower Fabrication',
  metaDescription: 'TEF fabricates distillation columns and process towers in titanium, nickel alloy and stainless steel for oil & gas and petrochemical applications.',
  sidebar: {
    title: 'Fabrication list',
    vessel: 'Fabrication Vessel',
    heatExchanger: 'Fabrication Heat Exchanger',
    piping: 'Fabrication Piping',
    tower: 'Fabrication Tower',
    muffle: 'Fabrication Muffle',
    radiantTube: 'Fabrication Radiant Tube',
    otherEquipment: 'Fabrication Other Equipment',
  },
  fabricationOf: 'Fabrication of',
  productName: 'Tower',
  description: 'Below is a catalog of our experience in Tower fabrication across various materials, types, and specifications.',
};
